
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: 'catalog-product-list-size-select'
})
export default class extends Vue {
  @Prop({default: () => []}) private pageSizes: Array<object>;
  @Prop({required: true}) private dataSource: string;

  private get selectedPageSize(): number {
    return this.$store.getters[`${this.dataSource}/pageSize`];
  }

  private set selectedPageSize(value) {
    this.$store.dispatch(`${this.dataSource}/updatePageSize`, value);
  }
}
